export var BulkValidationErrors;
(function (BulkValidationErrors) {
    BulkValidationErrors["PHONE_CONVERSATION_NOT_SUPPORTED"] = "PHONE_CONVERSATION_NOT_SUPPORTED";
    BulkValidationErrors["FACEBOOK_MESSENGER_OUTBOUND_EXPIRED"] = "FACEBOOK_MESSENGER_OUTBOUND_EXPIRED";
    BulkValidationErrors["WHATSAPP_OUTBOUND_EXPIRED"] = "WHATSAPP_OUTBOUND_EXPIRED";
    BulkValidationErrors["VOICEMAIL_CONVERSATION_NOT_SUPPORTED"] = "VOICEMAIL_CONVERSATION_NOT_SUPPORTED";
    BulkValidationErrors["CALLBACK_CONVERSATION_NOT_SUPPORTED"] = "CALLBACK_CONVERSATION_NOT_SUPPORTED";
})(BulkValidationErrors || (BulkValidationErrors = {}));
export var BulkValidationTypes;
(function (BulkValidationTypes) {
    BulkValidationTypes["SEND_REPLY"] = "SEND_REPLY";
})(BulkValidationTypes || (BulkValidationTypes = {}));
